import React from 'react';
import Front  from './components/basic/Front';

const App = () => {
  return (
    <Front />
  )
};

export default App;
